import { render } from "./ComplianceItem.vue?vue&type=template&id=52634eec&scoped=true"
import script from "./ComplianceItem.vue?vue&type=script&lang=js"
export * from "./ComplianceItem.vue?vue&type=script&lang=js"

import "./ComplianceItem.vue?vue&type=style&index=0&id=52634eec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52634eec"]])

export default __exports__